import { render } from "./CompanyItem.vue?vue&type=template&id=b7943542"
import script from "./CompanyItem.vue?vue&type=script&lang=js"
export * from "./CompanyItem.vue?vue&type=script&lang=js"

import "./CompanyItem.vue?vue&type=style&index=0&id=b7943542&lang=scss"

import exportComponent from "/opt/boarddata/boarddata.io/django/templates/frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__